export const HUBS_LOAD_REQUEST = 'HUBS_LOAD_REQUEST';
export const HUBS_LOAD_SUCCESS = 'HUBS_LOAD_SUCCESS';
export const HUBS_LOAD_FAILURE = 'HUBS_LOAD_FAILURE';
